import axiosInstance from 'custom-axios';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useTheme } from '@material-ui/core/styles';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import AssetAllocation from 'views/user-components/pages/dashboard/AssetAllocation';
import { numberFormat } from 'hooks/useNumberFormat';
import { Box, Button, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, SwipeableDrawer } from '@mui/material';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import QuickViewDrawer from 'views/user-components/pages/dashboard/QuickViewDrawer';
import useDebounce from 'hooks/useDebounce';

const contacts = [
    { name: 'Alice', phoneNumber: '123-456-7890' },
    { name: 'Bob', phoneNumber: '987-654-3210' },
    { name: 'Eve', phoneNumber: '555-123-4567' },
    { name: 'Evening', phoneNumber: '555-123-4567' },

    // ... other contacts ...
];

const Test = () => {

    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);

    const debouncedSearchQuery = useDebounce(searchQuery, 300); // Debounce time in milliseconds

    const generateRpcPdf = async () => {

        try {
            const response = await axiosInstance.get(`api/download-pdf`);
            // console.log(response)

        } catch (error) {
            toast.error(error.message)
        }
    }

    useEffect(() => {
        const filteredResults = contacts.filter(contact =>
            contact.name.toLowerCase().includes(debouncedSearchQuery.toLowerCase())
        );
        setSearchResults(filteredResults);
    }, [debouncedSearchQuery]);

    const handleInputChange = (event) => {
        const newQuery = event.target.value;
        setSearchQuery(newQuery);
    };


    return (
        <>

            <div>
                <h2>Real-Time Search with Debounce</h2>
                <input
                    type="text"
                    placeholder="Search by name"
                    value={searchQuery}
                    onChange={handleInputChange}
                />
                <ul>
                    {searchResults.map(contact => (
                        <li key={contact.name}>
                            <p>Name: {contact.name}</p>
                            <p>Phone Number: {contact.phoneNumber}</p>
                        </li>
                    ))}
                </ul>

                <Button
                    // startIcon={<SaveIcon/>}
                    variant='contained'
                    className='raintree-btn-yellow'
                    onClick={generateRpcPdf}
                >
                    Submit
                </Button>
            </div>

        </>
    );
};

export default Test;
